import {
  INPUT_VALUE_WRAPPING_GIFT,
  INPUT_VALUE_WRAPPING_STANDART,
} from '@shared/common/product';
import type { IBookWrapping } from '@shared/jp/data/products';

export const wrappingDefault: IBookWrapping = {
  id: INPUT_VALUE_WRAPPING_STANDART,
  name: 'No',
  price: {
    value: 0,
    currency: '¥',
  },
  label: 'Standart Wrapping',
};

export const wrappingFilled: IBookWrapping = {
  id: INPUT_VALUE_WRAPPING_GIFT,
  name: 'Gift Wrapping',
  price: {
    value: 300,
    currency: '¥',
  },
  image: 'assets/images/cart-select-option-photo.jpg',
  description:
    'We will wrap the picture book in the wrapping paper, and we will deliver it with a ribbon. To one important book of the important child.',
};

export const wrappings: IBookWrapping[] = [wrappingFilled, wrappingDefault];

/**  default product object */
// export c onst product: Product = {
//   alias: BOOK_ALIAS_STARR Y_DREAM,
//   boo kId: '',
//   type: '絵 本',
//   name: '”ほしの ゆめ”',
//   cover: ' soft',
//   hero:  'Yuri',
//   price:  3900,
//   currency: '円',
//   image: 'assets/images/ cart-product-ph oto.jpg',
//   wrappings,
//    wrapping: wrappingDefault
// }
